import { PosologyTypeEnum } from "common/enums/PosologyTypeEnum";
import { PeriodEnum } from "common/enums/PeriodEnum";

export interface PosologyType {
  readonly type: PosologyTypeEnum;
  readonly posologyText: string;
  readonly periodNumber?: number;
  readonly periodUnit?: PeriodEnum;
}

export class Posology implements PosologyType {
  readonly type: PosologyTypeEnum;
  readonly posologyText: string;
  readonly periodNumber?: number;
  readonly periodUnit?: PeriodEnum;

  constructor(data?: PosologyType) {
    this.type = PosologyTypeEnum.FREE_TEXT;
    this.posologyText = "";
    data && Object.assign(this, data);
  }
}
